/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Asset_RentalInputs */

const en_fulfillment_asset_rental = /** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short-Term Rental`)
};

const es_fulfillment_asset_rental = /** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler a Corto Plazo`)
};

const fr_fulfillment_asset_rental = /** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location à court terme`)
};

const de_fulfillment_asset_rental = /** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzzeitmiete`)
};

const id_fulfillment_asset_rental = /** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sewa Jangka Pendek`)
};

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const ja_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const zh_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const ar_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const it_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const ru_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const pt_fulfillment_asset_rental = en_fulfillment_asset_rental;

/** @type {(inputs: Fulfillment_Asset_RentalInputs) => LocalizedString} */
const ko_fulfillment_asset_rental = en_fulfillment_asset_rental;

/**
* | output |
* | --- |
* | "Short-Term Rental" |
*
* @param {Fulfillment_Asset_RentalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_asset_rental = /** @type {((inputs?: Fulfillment_Asset_RentalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Asset_RentalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_asset_rental(inputs)
	if (locale === "es") return es_fulfillment_asset_rental(inputs)
	if (locale === "fr") return fr_fulfillment_asset_rental(inputs)
	if (locale === "de") return de_fulfillment_asset_rental(inputs)
	if (locale === "ja") return ja_fulfillment_asset_rental(inputs)
	if (locale === "zh") return zh_fulfillment_asset_rental(inputs)
	if (locale === "ar") return ar_fulfillment_asset_rental(inputs)
	if (locale === "id") return id_fulfillment_asset_rental(inputs)
	if (locale === "it") return it_fulfillment_asset_rental(inputs)
	if (locale === "ru") return ru_fulfillment_asset_rental(inputs)
	if (locale === "pt") return pt_fulfillment_asset_rental(inputs)
	return ko_fulfillment_asset_rental(inputs)
});